<template>
  <div class="progress-layout">
    <div class="progress-wrap">
      <div :class="{ 'step': true, 'step-last': (n + 1) === progress.length }" v-for="step, n in progress">
        <div :class="{ 'point-wrap': true }">
          <div :class="{ point: true, 
                        'done-step': n <= indOfThisStep, 
                        'current-step': n === indOfThisStep, }">
            <p>{{ n + 1 }}</p>
          </div>
          <p class="point-title">{{ step.zh }}</p>
        </div>
        <!-- <div class="step-line" v-if="(n + 1) !== progress.length"></div> -->
      </div>
    </div>
    <patient-info v-if="currentSchedule && $store.state.currentApp.name === '醫囑取藥'"/>
  </div>
</template>

<script>
import PatientInfo from './PatientInfo';

export default {
  name: 'ProgressBar',
  components: {
    PatientInfo,
  },
  computed: {
    indOfThisStep() {
      const steps = [];
      this.progress.forEach((step) => {
        steps.push(step.en);
      });
      // console.log(steps.indexOf(this.currentStep));
      return steps.indexOf(this.currentStep);
    },
    progress() {
      // console.log(this.$store.state.progress);
      return this.$store.state.progress;
    },
    currentStep() {
      return this.$store.state.currentStep;
    },
    currentSchedule() {
      return this.$store.getters.currentSchedule;
    },
  },
};
</script>

<style lang="sass" scoped>
.progress-layout
  width: 100%
  height: 100px
  background: #f4f4f4
  border-bottom: 1px solid darken(#f4f4f4, 10%)
  display: flex;
  flex-direction: row
  justify-content: space-evenly;

.progress-wrap
  display: flex;
  justify-content: center;
  padding-top: 18px;


.step
  .point
    height: 30px
    width: 30px
    border-radius: 50%
    border: 3px solid cadetblue
    background-color: white
    text-align: center
    margin-bottom: 15px
  display: flex
  justify-content: center
  position: relative
  width: 110px
  // margin-right: 100px
  // margin-right: 100px
  &:after
    content: ''
    border-right: 40px solid
    border-left: 40px solid
    height: 2px
    position: absolute
    left: 70px
    top: 15px
  &:last-child
    margin-right: 0px
    &:after
      width: 0px
      border: 0px

.point-title
  white-space: nowrap;

.point-wrap
  display: flex;
  flex-direction: column;
  align-items: center;
  // justify-content: center

.step--last
  margin-right: 0px
  width: 0px
  border: 0px


.done-step
  border-color: #FF3811 !important

.current-step
  animation-duration: 2s;
  animation-name: backgroundChanged;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  ~p
    color: #FF3811

@keyframes backgroundChanged
  0%
    background: #FF3811;
    color: white
  100%
    background: transparent;

</style>



// WEBPACK FOOTER //
// ProgressBar.vue?f3025be8